export const GRADES_LIST = [
    {
        'id': 'IT',
        'name': 'IT - Infant/toddler'
    },
    {
        'id': 'PR',
        'name': 'PR - Preschool'
    },
    {
        'id': 'PK',
        'name': 'PK - Prekindergarten'
    },
    {
        'id': 'TK',
        'name': 'TK - Transitional Kindergarten'
    },
    {
        'id': 'KG',
        'name': 'KG - Kindergarten'
    },
    {
        'id': '1',
        'name': '1 - First grade'
    },
    {
        'id': '2',
        'name': '2 - Second grade'
    },
    {
        'id': '3',
        'name': '3 - Third grade'
    },
    {
        'id': '4',
        'name': '4 - Fourth grade'
    },
    {
        'id': '5',
        'name': '5 - Fifth grade'
    },
    {
        'id': '6',
        'name': '6 - Sixth grade'
    },
    {
        'id': '7',
        'name': '7 - Seventh grade'
    },
    {
        'id': '8',
        'name': '8 - Eighth grade'
    },
    {
        'id': '9',
        'name': '9 - Ninth grade'
    },
    {
        'id': '10',
        'name': '10 - Tenth grade'
    },
    {
        'id': '11',
        'name': '11 - Eleventh grade'
    },
    {
        'id': '12',
        'name': '12 - Twelfth grade'
    },
    {
        'id': '13',
        'name': '13 - Thirteenth grade'
    },
    {
        'id': 'PS',
        'name': 'PS - Postsecondary'
    },
    {
        'id': 'UG',
        'name': 'UG - Ungraded'
    },
    {
        'id': 'Other',
        'name': 'Other'
    },
    {
        'id': 'INVALID',
        'name': 'INVALID - Invalid grade'
    }
];

export const GradeMap = new Map<string, string>([
    ['INFANT_TODDLER', 'IT'],
    ['IT - Infant/toddler', 'IT'],
    ['PRE_SCHOOL', 'PR'],
    ['PR - Preschool', 'PR'],
    ['PRE_KINDERGARTEN', 'PK'],
    ['PK - Prekindergarten', 'PK'],
    ['TRANSITIONAL_KINDERGARTEN', 'TK'],
    ['TK - Transitional Kindergarten', 'TK'],
    ['KINDERGARTEN', 'KG'],
    ['KG - Kindergarten', 'KG'],
    ['YEAR_1', '1'],
    ['1 - First grade', '1'],
    ['YEAR_2', '2'],
    ['2 - Second grade', '2'],
    ['YEAR_3', '3'],
    ['3 - Third grade', '3'],
    ['YEAR_4', '4'],
    ['4 - Fourth grade', '4'],
    ['YEAR_5', '5'],
    ['5 - Fifth grade', '5'],
    ['YEAR_6', '6'],
    ['6 - Sixth grade', '6'],
    ['YEAR_7', '7'],
    ['7 - Seventh grade', '7'],
    ['YEAR_8', '8'],
    ['8 - Eighth grade', '8'],
    ['YEAR_9', '9'],
    ['9 - Ninth grade', '9'],
    ['YEAR_10', '10'],
    ['10 - Tenth grade', '10'],
    ['YEAR_11', '11'],
    ['11 - Eleventh grade', '11'],
    ['YEAR_12', '12'],
    ['12 - Twelfth grade', '12'],
    ['YEAR_13', '13'],
    ['13 - Thirteenth grade', '13'],
    ['POST_SECONDARY', 'PS'],
    ['PS - Postsecondary', 'PS'],
    ['UNGRADED', 'UG'],
    ['UG - Ungraded', 'UG'],
    ['OTHER', 'Other'],
    ['Other', 'Other'],
    ['INVALID_GRADE', 'INVALID'],
    ['INVALID - Invalid grade', 'INVALID']
]);
